import * as React from 'react'
import { cn } from '../utils'
import { StatusChip } from './status-chip'
import { semanticTokens } from '@supabank/config/theme'

type Step = {
  id: string
  title: string
  description?: string
}

type StepperProps = React.HTMLAttributes<HTMLOListElement> & {
  steps: Step[]
  animated?: boolean
}

export function Stepper({ steps, className, animated = false, ...props }: StepperProps) {
  return (
    <ol
      className={cn('space-y-6', semanticTokens.motion.standard, className)}
      {...props}
    >
      {steps.map((step, index) => (
        <li
          key={step.id}
          className={cn(
            'relative pl-12',
            animated && 'motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-2',
            animated && semanticTokens.motion.reduced
          )}
          style={animated ? { animationDelay: `${index * 120}ms` } : undefined}
        >
          {index < steps.length - 1 && (
            <span
              aria-hidden="true"
              className={cn(
                'absolute left-5 top-10 h-full w-px rounded-full',
                semanticTokens.harmony.calm.border.replace('border', 'bg'),
                animated && 'motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-top-2'
              )}
            />
          )}
          <div className="absolute left-0 top-0">
            <StatusChip intent="info" tone="quiet" size="md">
              {index + 1}
            </StatusChip>
          </div>
          <div
            className={cn(
              'rounded-lg border p-4',
              semanticTokens.harmony.calm.bg,
              semanticTokens.harmony.calm.border,
              semanticTokens.harmony.calm.shadow,
              semanticTokens.radius.lg,
              animated && semanticTokens.motion.standard
            )}
          >
            <h3 className={cn(semanticTokens.typography.h3, semanticTokens.fg.default)}>
              {step.title}
            </h3>
            {step.description && (
              <p className={cn('mt-2', semanticTokens.typography.body, semanticTokens.fg.muted)}>
                {step.description}
              </p>
            )}
          </div>
        </li>
      ))}
    </ol>
  )
}
